import {makeStyles} from '@material-ui/core/styles';
import React, {useState, useEffect} from 'react';
import Collections from "./Utils/collections";
import {
    useHistory,
    Route
} from 'react-router-dom'
import NavBar from './NavBar/NavBar'
import AuthService from "./Services/AuthService";
import Login from './Login/Login'
import LoginPDL from './Login/LoginPDL'
import MisMetas from './Objetivos/Objetivos'
import MiPerfil from './Perfil/Perfil'
import ResetPass from './Login/ResetPass'
import CreatePassword from './Login/CreatePassword'
import Recruitment from './Reclutamiento/Reclutamiento'
import InvitacionReclutamiento from './Reclutamiento/InvitacionReclutamiento'
import PreRegistroStep1 from './Reclutamiento/PreRegistroStep1'
import PreRegistroSigned from './Reclutamiento/PreRegistroSigned'
import Answering from './Asistire/Asistire'
import Inicio from './Inicio/Inicio'
import Objetivos from './Inicio/Objetivos'
import Directorio from './Directorio/Directorio'
import Canales from './Canales/Canales'
import Recursos from './Recursos/Recursos'
import Compensaciones from './Compensaciones/Compensaciones'
import Training from './Recursos/Training'
import Promociones from './Recursos/Promociones'
import Ajustes from './Ajustes/Ajustes'
import GestionAdmins from './Ajustes/GestionAdmins'
import Calendario from './Calendario/Calendario'
import Eventos from './NavBar/ListadoEventos'
import PaseDeListaJVsForm from './PaseDeListaJVs/PaseDeListaJVsForm'
import io from 'socket.io-client';
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {css} from "glamor";
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';


const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
        backgroundColor: '#fff',
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    LogoHolder: {
        marginTop: '10px',
        marginBottom: '10px'
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        color: 'black',
        flexGrow: 1,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        height:"100%"
    },
    sideMenus:{
        height:"100vh"
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: 0, //theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 850,
    },
    search: {
        color: 'black',
        flexGrow: 4,
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        // backgroundColor: alpha(theme.palette.common.white, 0.15),
        backgroundColor: 'rgba(255,255,255,0.15)',
        '&:hover': {
            // backgroundColor: alpha(theme.palette.common.white, 0.25),
            backgroundColor: 'rgba(255,255,255,0.15)',
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    inputRoot: {
        color: 'black',
        marginLeft: '50px'
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

const App = () => {
    let history = useHistory();
    const classes = useStyles();
    const [currentUser, setCurrentUser] = useState(AuthService.getCurrentUser());
    const [hstrl, setHstrl] = useState(window.localStorage.getItem("titleToolbar") || '');
    const [dataRecruitment, setDataRecruitment] = useState("");
    const [dataAnswering, setDataAnswering] = useState("");
    const [dataCreatePassword, setDataCreatePassword] = useState("");
    const socket = io(Collections.ipServer, {
        transports: ['websocket'],
        upgrade: false
    });
    const [dataPaseDeListaJVsForm, setdataPaseDeListaJVsForm] = useState("");
    const [dataLoginPDL, setdataLoginPDL] = useState("");
    const [onPaseDeListaJVs, setonPaseDeListaJVs] = useState(false);
    const isPreRegistroPath = window.location.pathname === '/preregistro' || window.location.pathname === '/preregistro/';
    const isPreRegistroSignedPath = window.location.pathname === '/preregistrosigned' || window.location.pathname === '/preregistrosigned/';

    const handlePDLredirect = (path, titleToolbar) => {
        window.localStorage.setItem('titleToolbar', titleToolbar)
        history.push(path);
    }


    useEffect(() => {
        const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
        if (path) {
            history.replace(path);
        }
        const user = AuthService.getCurrentUser();
       
        var VersionCheckPoint = localStorage.getItem("VersionCheckPoint");
        console.log('------> El valor de VersionCheckPoint es: '+VersionCheckPoint);
        if(!VersionCheckPoint){
            localStorage.setItem("VersionCheckPoint", Collections.CurrentAppVersion);
            AuthService.logout();
            window.location.reload();
        } else if (VersionCheckPoint !== Collections.CurrentAppVersion){
            localStorage.setItem("VersionCheckPoint", Collections.CurrentAppVersion);
            AuthService.logout();
            window.location.reload();
        }
        console.log('Environment IPserver:' +Collections.ipServer);
        console.log(btoa(user));
        if (user) {
            AuthService.UserStatusCheck(user.correo)
                .then(resp =>{
                    if(resp === true){
                        AuthService.logout();
                        window.location.reload();
                    }
                });
            setCurrentUser(user);
            AuthService.consult(`{ventasApi{ id idRqst ssid status message results createdAt updatedAt }}`)
                .then(resp =>{
                    let ventasApi = resp.data.data.ventasApi;
                    if(ventasApi.length>0){
                        window.localStorage.setItem('idApiVentas', JSON.stringify(resp.data.data.ventasApi[0]));
                    }
                });
        }
        if(window.location.pathname === '/recruitment'){
            if(window.location.search && window.location.search.length>0){
                setDataRecruitment(window.location.search);
                window.localStorage.setItem('titleToolbar', 'recruitment');
                history.push('/recruitment');
                setHstrl('/recruitment');
            } else {
                window.localStorage.removeItem('titleToolbar');
                setHstrl('');
            }
        }
        if(window.location.pathname === '/answering'){
            if(window.location.search && window.location.search.length>0){
                setDataAnswering(window.location.search);
                window.localStorage.setItem('titleToolbar', 'answering');
                history.push('/answering');
                setHstrl('/answering');
            } else {
                window.localStorage.removeItem('titleToolbar');
                setHstrl('');
            }
        }
        
        if(window.location.pathname === '/createPassword'){
            if(window.location.search && window.location.search.length>0){
                setDataCreatePassword(window.location.search);
                window.localStorage.setItem('titleToolbar', 'createPassword');
                history.push('/createPassword');
                setHstrl('/createPassword');
            } else {
                window.localStorage.removeItem('titleToolbar');
                setHstrl('');
            }
        }

        if (
            window.location.pathname === '/ReclutaHoy' ||
            window.location.pathname === '/ReclutaHoy/' ||
            window.location.pathname === '/invitacion-reclutamiento' ||
            window.location.pathname === '/invitacion-reclutamiento/'
        ) {
            window.localStorage.setItem('titleToolbar', 'invitacion-reclutamiento');
            history.push('/invitacion-reclutamiento/');
            setHstrl('invitacion-reclutamiento');
        }

        if(window.location.pathname === '/PaseDeListaJVs'){
            setonPaseDeListaJVs(true);
            handlePDLredirect('/PaseDeListaJVs','PaseDeListaJVs');
        }

        if(window.location.pathname === '/pasedelistajvs'){

            setonPaseDeListaJVs(true);
            handlePDLredirect('/PaseDeListaJVs','PaseDeListaJVs');

            setdataPaseDeListaJVsForm(window.location.search);
            window.localStorage.setItem('titleToolbar', 'PaseDeListaJVs');
            history.push('/PaseDeListaJVs');
            setHstrl('/pasedelistajvs');
        }

        if(window.location.pathname === '/LoginPDL'){
            setonPaseDeListaJVs(true);
            handlePDLredirect('/LoginPDL','LoginPDL');
        }

        if(window.location.pathname === '/loginpdl'){
            setonPaseDeListaJVs(true);
            handlePDLredirect('/LoginPDL','LoginPDL');
            setdataLoginPDL(window.location.search);
            window.localStorage.setItem('titleToolbar', 'LoginPDL');
            history.push('/LoginPDL');
            setHstrl('/LoginPDL');
        }

        if (!isPreRegistroPath && !isPreRegistroSignedPath) {
            let hstr = window.localStorage.getItem("titleToolbar");
            history.push("/" + (hstr ? hstr.replace("?add=true", "").replace(" ", "") : '').toLowerCase());
        }
        if (!user) {
            if(window.location.pathname !== '/resetpass' && !isPreRegistroPath && !isPreRegistroSignedPath) {
                AuthService.logout();
            }
        }
        
    }, []);

    if (isPreRegistroPath) {
        return (
            <div>
                <ToastContainer
                    autoClose={5000}
                    className="toast-container"
                    toastClassName="dark-toast"
                    progressClassName={css({
                        height: "2px"
                    })}
                />
                <PreRegistroStep1 isSignedIn={!!currentUser} />
            </div>
        );
    }

    if (isPreRegistroSignedPath) {
        return (
            <div>
                <ToastContainer
                    autoClose={5000}
                    className="toast-container"
                    toastClassName="dark-toast"
                    progressClassName={css({
                        height: "2px"
                    })}
                />
                <PreRegistroSigned />
            </div>
        );
    }

    return (
            <div>
                <ToastContainer
                    autoClose={5000}
                    className="toast-container"
                    toastClassName="dark-toast"
                    progressClassName={css({
                        height: "2px"
                    })}
                />
                {currentUser && !onPaseDeListaJVs ? (

                        <div className={classes.root}>
                            <CssBaseline/>

                            <NavBar classes={classes} datauser={currentUser} socket={socket}/>

                            <main style={{
                                flexGrow: 1,
                                height: "100vh",
                                overflow: "auto"
                            }}>
                                <Container maxWidth="lg" className='main_div'>

                                    <div className="col s12 container-setup" style={{marginTop: "68px"}}>
                                        {
                                            currentUser.updatePassword ?
                                                <MiPerfil classes={classes} user={currentUser} editar={true}/>
                                                :
                                            (hstrl==='Calendario' || hstrl==='Calendario?add=true') ?
                                                <Calendario classes={classes} datauser={currentUser} socket={socket}/>
                                                :
                                                (hstrl==='Directorio') ?
                                                    <Directorio classes={classes} datauser={currentUser} />
                                                    :
                                                    (hstrl==='Canales de comunicación') ?
                                                        <Canales classes={classes} datauser={currentUser} />
                                                        :
                                                    (hstrl==='Mis Compensaciones') ?
                                                        <Compensaciones classes={classes} user={currentUser}/>
                                                        :
                                                    (hstrl==='Ajustes') ?
                                                        <Ajustes classes={classes} />
                                                    :
                                                    (hstrl==='Gestionar Administradores') ?
                                                        <GestionAdmins classes={classes} />
                                                        :
                                                        (hstrl==='Objetivos') ?
                                                            <Objetivos classes={classes} user={currentUser}/>
                                                        :
                                                        (hstrl==='Recursos') ?
                                                            <Recursos classes={classes} user={currentUser}/>
                                                            :
                                                            (hstrl==='Training') ?
                                                            <Training classes={classes} user={currentUser}/>
                                                            :
                                                            (hstrl==='Promociones') ?
                                                            <Promociones classes={classes} user={currentUser}/>
                                                            :
                                                                (hstrl==='invitacion-reclutamiento' || hstrl==='ReclutaHoy') ?
                                                                <InvitacionReclutamiento />
                                                                :
                                                            (hstrl==='Mi Perfil') ?
                                                                <MiPerfil classes={classes} user={currentUser} editar={true}/>
                                                                :
                                                                (hstrl==='Mis Metas') ?
                                                                    <MisMetas classes={classes} user={currentUser} />
                                                                :
                                                                (hstrl==='Eventos') ?
                                                                    <Eventos classes={classes} user={currentUser}/>
                                                                    :
                                                                    <Inicio classes={classes} user={currentUser}/>
                                        }
                                    </div>
                                </Container>
                            </main>
                        </div>
                    ) :
                    (
                        <div className="container mt-3">
                            {
                                window.location.pathname === '/loginpdl' ?
                                    <LoginPDL datos={dataLoginPDL}/>
                                    :
                                window.location.pathname === '/pasedelistajvs' ?
                                    <PaseDeListaJVsForm datos={dataPaseDeListaJVsForm}/>
                                    :
                                (hstrl === '' || hstrl === '/') ?
                                    <Route exact path="*" component={Login}/>
                                    :
                                hstrl.indexOf('recruitment')>=0 && dataRecruitment.length>0 ?
                                    <Recruitment datos={dataRecruitment}/>
                                    :
                                hstrl.indexOf('answering')>=0 && dataAnswering.length>0 ?
                                    <Answering datos={dataAnswering}/>
                                    :
                                hstrl.indexOf('PaseDeListaJVs')>=0 && dataPaseDeListaJVsForm.length>=0 ?
                                    <PaseDeListaJVsForm datos={dataPaseDeListaJVsForm}/>
                                    :
                                window.location.pathname === '/pasedelistajvs' ?
                                    <PaseDeListaJVsForm datos={dataPaseDeListaJVsForm}/>
                                    :
                                hstrl.indexOf('createPassword')>=0 && dataCreatePassword.length>0 ?
                                    <CreatePassword datos={dataCreatePassword}/>
                                    :
                                    <Route path="/resetPass" component={ResetPass}/>
                            }
                        </div>
                    )
                }

            </div>
    )
};

export default App;